import { Group, MultiSelect, Select } from '@mantine/core';

const categories = {
  PREMIUM: 'Premium',
  BASIC: 'Standard',
  FREE: 'Core',
};

const StripoTemplatesFilter = ({ filterOptions, currentFilters, onFilterChange }) => {
  const handleSelect = (event) => {
    let name = event.name;
    let value = event.value;

    if (['PREMIUM', 'BASIC', 'FREE'].includes(value)) {
      name = 'type';
    }
    onFilterChange(name, value);
  };

  return (
    <Group mb="md" wrap="wrap">
      <Select
        name="categories"
        data={Object.entries(categories).map(([value, label]) => ({
          value,
          label,
        }))}
        placeholder="Categories"
        onChange={(value) => handleSelect({ name: 'type', value })}
        value={currentFilters.type}
      />

      <MultiSelect
        name="templateFeatures"
        data={filterOptions?.templateFeatures.map((feature) => ({
          value: feature.id?.toString(),
          label: feature.name,
        }))}
        placeholder="Feature"
        value={currentFilters?.templateFeatures}
        onChange={(value) => handleSelect({ name: 'templateFeatures', value })}
      />

      <MultiSelect
        name="templateTypes"
        data={filterOptions?.templateTypes.map((type) => ({ value: type.id?.toString(), label: type.name }))}
        placeholder="Type"
        value={currentFilters?.templateTypes}
        onChange={(value) => handleSelect({ name: 'templateTypes', value })}
      />

      <MultiSelect
        name="templateIndustries"
        data={filterOptions?.templateIndustries.map((industry) => ({
          value: industry.id?.toString(),
          label: industry.name,
        }))}
        placeholder="Industry"
        value={currentFilters?.templateIndustries}
        onChange={(value) => handleSelect({ name: 'templateIndustries', value })}
      />

      <MultiSelect
        name="templateSeasons"
        data={filterOptions?.templateSeasons.map((season) => ({ value: season.id?.toString(), label: season.name }))}
        placeholder="Season"
        value={currentFilters?.templateIndustries}
        onChange={(value) => handleSelect({ name: 'templateSeasons', value })}
      />
    </Group>
  );
};

export default StripoTemplatesFilter;
